<template>

  <generic-card
      :byContent="true"
      :allowDelete="allowDelete"

      @click="$emit('click')"
      @delete="$emit('deleteVatDeclaration')"

  >
    <template #content>
      <content-vat-declaration
          :vatDeclaration="vatDeclaration"
          :isParentMethodPriority="true"
          :isPayable="isPayable"
          :isDownloadable="isDownloadable"
          :isViewable="isViewable"
          :isDeletable="false"
          :is-selected="isSelected"
          @view="$emit('view')"
          @pay="$emit('pay')"
      />
    </template>

  </generic-card>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import GenericCard from './Card'
import ContentVatDeclaration from './components/VatDeclaration.vue'

export default {
  components: {
    GenericCard,
    ContentVatDeclaration
  },
  props: {
    vatDeclaration: {
      type: Object,
      default: () => {}
    },
    isDownloadable: {
      type: Boolean,
      default: true
    },
    isViewable: {
      type: Boolean,
      default: false,
    },
    isPayable: {
      type: Boolean,
      default: false
    },
    allowDelete: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>